<template>
  <div>
    <v-toolbar flat class="d-print-none">
      <ProductionSelector
        :dates="dates"
        :production="production"
        v-on:update:dates="dates=$event"
        v-on:update:production="production=$event"
      />
      <v-spacer/>
    </v-toolbar>

    <v-container fluid>
      <v-alert v-if="!hasDates" type="info" outlined>
        Choose a production to open a report for it.
      </v-alert>

      <v-list two-line>
        <v-list-item
          v-for="report of reports"
          :key="report.name"
          :data-cy="`report-${report.name}`"
        >
          <v-list-item-content>
            <v-list-item-title>
              <router-link v-if="hasDates" :to="locationFor(report)">{{ report.title }}</router-link>
              <span v-else>{{ report.title }}</span>
            </v-list-item-title>
            <v-list-item-subtitle>{{ report.description }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              outlined
              :disabled="!hasDates"
              :to="hasDates ? locationFor(report) : undefined"
            >
              Open
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-container>
  </div>
</template>

<script>
import urlState from '@/router/urlState';
import ProductionSelector from '@/components/ProductionSelector.vue';

/**
 * The reports this page offers. Each one is an ordinary kitchen page that takes the
 * production's dates in its url, so it opens here and prints with the app bar's pdf
 * button like any other page. Add a report by adding an entry and its route.
 */
export const REPORTS = [
  {
    name: 'ChefsChoiceDemand',
    title: "Chef's Choice demand",
    description: 'Every chef\'s choice meal with the quantity ordered in each production group, '
      + 'and columns for the plater, a check and the manager.',
  },
];

export default {
  name: 'Reports',
  components: {ProductionSelector},
  mixins: [urlState],
  data() {
    return {
      dates: [],
      production: undefined,
      reports: REPORTS,
    };
  },
  mounted() {
    this.syncToUrl({
      param: 'dates', urlParam: 'dates', initFromRoute: true,
      parseCallback: v => (Array.isArray(v) ? v : [v]).filter(Boolean),
    });
    this.syncToUrl({param: 'production', urlParam: 'production', initFromRoute: true});
  },
  computed: {
    hasDates() {
      return !!(this.dates && this.dates.length > 0);
    },
  },
  methods: {
    locationFor(report) {
      const query = {dates: this.dates};
      if (this.production) {
        query.production = this.production;
      }
      return {name: report.name, query};
    },
  },
};
</script>
